import { render, staticRenderFns } from "./PriceWidget.vue?vue&type=template&id=c222b03e&scoped=true"
import script from "./PriceWidget.vue?vue&type=script&lang=js"
export * from "./PriceWidget.vue?vue&type=script&lang=js"
import style0 from "./PriceWidget.vue?vue&type=style&index=0&id=c222b03e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c222b03e",
  null
  
)

export default component.exports